import { useTranslation } from 'react-i18next'
import { Lightbulb, Check } from 'lucide-react'
import type { Suggestion } from '../hooks/use-ai-assistant'

// Field label mapping (includes variations AI might use)
const FIELD_LABELS: Record<string, { en: string; fr: string }> = {
  description: { en: 'Description', fr: 'Description' },
  objective: { en: 'Objective', fr: 'Objectif' },
  objectif: { en: 'Objective', fr: 'Objectif' },
  targetusers: { en: 'Target Users', fr: 'Utilisateurs cibles' },
  target_users: { en: 'Target Users', fr: 'Utilisateurs cibles' },
  utilisateurs: { en: 'Target Users', fr: 'Utilisateurs cibles' },
  cible: { en: 'Target Users', fr: 'Utilisateurs cibles' },
  constraints: { en: 'Constraints', fr: 'Contraintes' },
  contraintes: { en: 'Constraints', fr: 'Contraintes' },
  inspirations: { en: 'Inspirations', fr: 'Inspirations' },
}

interface SuggestionCardProps {
  suggestion: Suggestion
  onUse: () => void
}

export function SuggestionCard({ suggestion, onUse }: SuggestionCardProps) {
  const { t, i18n } = useTranslation()
  const normalizedField = suggestion.field.toLowerCase()
  const fieldLabel =
    FIELD_LABELS[normalizedField]?.[i18n.language as 'en' | 'fr'] ||
    FIELD_LABELS[normalizedField]?.en ||
    suggestion.field

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-border bg-slate-50 p-4">
      {/* Header */}
      <div className="flex items-center gap-2">
        <Lightbulb className="h-[18px] w-[18px] text-amber-500" />
        <span className="text-xs font-semibold text-foreground">
          {t('precadrage.assistant.suggestionFor')} {fieldLabel}
        </span>
      </div>

      {/* Content */}
      <p className="text-[13px] leading-relaxed text-foreground">{suggestion.content}</p>

      {/* Actions */}
      <button
        type="button"
        onClick={onUse}
        className="flex items-center gap-1.5 rounded-md bg-accent px-3 py-2 text-xs font-medium text-white transition-colors hover:bg-accent-hover"
      >
        <Check className="h-4 w-4" />
        {t('precadrage.assistant.useSuggestion')}
      </button>
    </div>
  )
}
